import React from 'react';
import moment from 'moment';
import axios from 'axios';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import TimetableHeader from '../parts/TimetableHeader';
import TimetableEntry from '../parts/TimetableEntry';
import TimetablePupilNoteContentDialog
  from '../parts/Timetable/TimetablePupilNoteContentDialog';

const styles = () => ({
  padding: {
    padding: 20,
  },
  noPaddingTop: {
    paddingTop: 0,
  },
  paddingHorizontal: {
    paddingLeft: 20,
    paddingRight: 20,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class TimetablePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: moment().format('YYYY-MM-DD'),
      isLoading: false,
      isLoaded: false,
      data: [],
      meta: {},
      dates: [],
      showPupilNotesDialog: false,
    };

    this.axiosCancel = null;

    this.onCalendarDateChange = this.onCalendarDateChange.bind(this);
    this.onDateClick = this.onDateClick.bind(this);
    this.handleToggleShowPupilNotes = this.handleToggleShowPupilNotes.bind(this);
  }

  componentDidMount() {
    this.reloadData();

    window.addEventListener('timetable:save-note', (event) => {
      this.forceUpdate();
    });
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  onCalendarDateChange(dateMoment) {
    const date = dateMoment.format('YYYY-MM-DD');
    this.setState({
      selectedDate: date,
    });
    this.reloadData(date);
  }

  onDateClick(date) {
    this.setState({
      selectedDate: date,
    });
    this.reloadData(date);
  }

  handleToggleShowPupilNotes() {
    this.setState({
      showPupilNotesDialog: !this.state.showPupilNotesDialog,
    });
  }

  reloadData(date) {
    const {
      selectedPupil,
    } = this.props;

    if (!selectedPupil) {
      return;
    }

    this.setState({
      isLoading: true,
    });

    let dateQuery = '';
    if (date) {
      dateQuery = `?date=${date}`;
    }

    axios
      .get(
        `${window.apiUrl}/timetable/${selectedPupil.id}${dateQuery}`,
        {
          cancelToken: new axios.CancelToken((c) => {
            this.axiosCancel = c
          }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            meta: response.data.meta,
            data: response.data.data,
            dateStart: response.data.meta.start_date,
            dateEnd: response.data.meta.end_date,
            dates: response.data.meta.timetable_dates,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      classes,
      selectedPupil,
      t,
    } = this.props;
    const {
      selectedDate,
      data,
      dates,
    } = this.state;

    const timetableEntriesWithPupilNotes = data.filter(entry => {
      return entry.pupil_note.length > 0;
    });
    const pupilTimetableEntryNoteCount = timetableEntriesWithPupilNotes.length;

    return (
      <div className="timetable-page">
        <div className={classes.padding}>
          <TimetableHeader
            key={selectedDate}
            dates={dates}
            selectedDate={selectedDate}
            onCalendarDateChange={this.onCalendarDateChange}
            onDateClick={this.onDateClick}
            useSuspense={false}
          />
        </div>
        {data.length === 0
        && (
          <div className={classes.paddingHorizontal}>
            <p>No timetable data found for this date.</p>
          </div>
        )
        }
        {data.length !== 0 && (
          <div>
            {timetableEntriesWithPupilNotes.length > 0 && (
              <div className={`${classes.padding} ${classes.noPaddingTop}`}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleToggleShowPupilNotes}
                  className="toggle-pupil-notes-button"
                >
                  {t('Your notes ({{pupilTimetableEntryNoteCount}})', { pupilTimetableEntryNoteCount })}
                </Button>
                <TimetablePupilNoteContentDialog
                  isDialogOpen={this.state.showPupilNotesDialog}
                  onDialogClose={this.handleToggleShowPupilNotes}
                  timetableEntries={timetableEntriesWithPupilNotes}
                  useSuspense={false}
                />
              </div>
            )}
            {data.map(entry => (
              <TimetableEntry
                key={entry.key}
                allowAddTimetableNotes={selectedPupil.allow_pupils_add_timetable_notes}
                timetableNoteAbstractLength={300}
                ellipsis='...'
                data={entry}
              />
            ))}
          </div>
        )
        }
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withTranslation()(TimetablePage))
);
